document.addEventListener('DOMContentLoaded', function () {
  $('[data-bs-dismiss=toast]').click(function() {
    $(this).closest('.toast').addClass('hidden');
  });
});
